const basePalette = {
    primary: {
        main: '#0E223B',
        light: '#516275',
        dark: '#071221',
        contrastText: '#FFFFFF',
    },
    secondary: {
        main: '#516275',
        light: '#767A82',
        dark: '#15202B',
        contrastText: '#FFFFFF',
    },
    success: {
        main: '#2E7D32',
        light: '#81C784',
        dark: '#00391A',
        contrastText: '#FFFFFF',
    },
    warning: {
        main: '#F57C00',
        light: '#FFB74D',
        dark: '#3A2300',
        contrastText: '#FFFFFF',
    },
    info: {
        main: '#1976D2',
        light: '#90CAF9',
        dark: '#082338',
        contrastText: '#FFFFFF',
    },
    error: {
        main: '#BA1A1A',
        light: '#FFB4AB',
        dark: '#690005',
        contrastText: '#FFFFFF',
    },
    grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121',
    },
};

export const getDesignTokens = (mode) => ({
    palette: {
        mode,
        ...(mode === 'light'
            ? {
                  ...basePalette,
                  background: {
                      default: '#F8F9FA',
                      paper: '#FFFFFF',
                  },
                  text: {
                      primary: '#1B1B1F',
                      secondary: '#454A52',
                      disabled: '#767A82',
                  },
              }
            : {
                  ...basePalette,
                  primary: {
                      main: '#58A6FF',
                      light: '#79C0FF',
                      dark: '#1F6FEB',
                      contrastText: '#FFFFFF',
                  },
                  secondary: {
                      main: '#8B949E',
                      light: '#ADB5BD',
                      dark: '#6E7681',
                      contrastText: '#FFFFFF',
                  },
                  warning: {
                      main: '#A0621A',
                      light: '#C07830',
                      dark: '#6B3D0A',
                      contrastText: '#FFFFFF',
                  },
                  background: {
                      default: '#0D1117',
                      paper: '#161B22',
                  },
                  text: {
                      primary: '#E6EDF3',
                      secondary: '#9BA3AD',
                      disabled: '#636B76',
                  },
                  divider: 'rgba(48, 54, 61, 0.8)',
              }),
    },
    typography: {
        fontFamily: ['Manrope', 'sans-serif'].join(','),
        h5: {
            fontWeight: 700,
        },
        h6: {
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
            },
            defaultProps: {
                disableElevation: true,
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    boxShadow:
                        theme.palette.mode === 'light'
                            ? 'rgba(149, 157, 165, 0.1) 0px 8px 24px'
                            : 'none',
                    border:
                        theme.palette.mode === 'dark'
                            ? '1px solid rgba(48, 54, 61, 0.8)'
                            : 'none',
                }),
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: ({ theme }) => ({
                    backgroundColor:
                        theme.palette.mode === 'dark'
                            ? '#060A10'
                            : theme.palette.primary.main,
                    color: '#FFFFFF',
                    boxShadow: 'none',
                    border: 'none',
                }),
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: ({ theme }) => ({
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.light,
                    },
                }),
            },
        },
    },
});
